exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.welcome-wrapper {\n  z-index: 9999;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  background: #111;\n}\n.welcome-wrapper .welcome-main,\n.welcome-wrapper .welcome-secondary {\n  position: absolute;\n  left: 0;\n  width: 100vw;\n  object-fit: cover;\n}\n.welcome-wrapper .welcome-main {\n  top: 0;\n  height: 100vh;\n}\n.welcome-wrapper .welcome-secondary {\n  bottom: 0;\n  height: auto;\n}\n.welcome-wrapper .hide-btn {\n  position: fixed;\n  right: 4vw;\n  top: 3vh;\n  min-width: 1.9rem;\n  padding: 0.16rem 0.3rem;\n  background: rgba(0,0,0,0.55);\n  color: #fff;\n  border: none;\n  border-radius: 999px;\n  font-size: 0.3rem;\n  box-shadow: 0 0.08rem 0.24rem rgba(0,0,0,0.2);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fdcedba4","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Welcome.vue
// module id = W7QO
// module chunks = 15